import Amount from '@components/common/molecules/Amount';
import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface AddOrEditButtonProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const AddOrEditButton: React.FC<AddOrEditButtonProps> = observer(({ restaurantOfferStore }) => {
    const { orderFoodRequest, onAddOrEditFoodClick, foodAdditionalDrawerMode } = restaurantOfferStore;
    return (
        <Button
            size='medium'
            onClick={() => onAddOrEditFoodClick()}
            sx={{ width: "70%", boxShadow: (theme) => theme.shadows[3] }}
            variant='contained'
            color='secondary'>
            <Box display={"flex"} width={"100%"} flexDirection={"row"} justifyContent={"space-between"}>
                <Typography
                    textAlign={"start"}
                    variant='subtitle2'
                    color={"#fff"}
                    fontWeight={600}>
                    {foodAdditionalDrawerMode === "insert" ? "Dodaj u košaricu" : "Spremi promjene"}
                </Typography>
                <Amount amount={orderFoodRequest.totalAmount} color={"#fff"} width={"auto"} fontWeight={600} />
            </Box>
        </Button>
    )
})

export default AddOrEditButton;